export const renderISODate = (date: any) => {
	if (date) {
		if (date instanceof Date) {
			return date
				? date.toISOString().split('T')[0].split('-').reverse().join('/')
				: '';
		} else {
			return date;
		}
	}
};
